import { useGetCurrentUserVisibility } from '../queries/visibilityRules-query';

/**
 * Whether the current user has the client/customer visibility rule.
 *
 * Fail-closed: returns true while the underlying query is loading or has
 * errored, so client-only restrictions are applied conservatively when the
 * user's visibility state isn't yet known. A momentary "client view" flash
 * for a non-client is preferable to a momentary exposure of action surfaces
 * to a real client/customer.
 */
export const useIsClient = (): boolean => {
  const query = useGetCurrentUserVisibility();
  return query.isLoading || query.isError || !!query.data?.hasClientCustomer;
};
